import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useDisabledFields } from 'components/modules/Insurance/hooks/useDisabledFields';
import { Insurance } from 'constants/routes';
import { useRouteMatch } from 'hooks/useRouteMatch';
import * as CarInstanceActions from 'store/carInstance/actions';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceSelectors from 'store/carInstance/selectors';
import * as CarReferenceActions from 'store/carReference';
import * as CarReferenceConstants from 'store/carReference/constants';

const { ROUTES } = Insurance;

export const useVehicleStatusPresenter = () => {
  const dispatch = useDispatch();

  const { [CarInstanceConstants.VALUE_FIELDS.IS_NEW]: isNew } = useSelector(
    CarInstanceSelectors.selectValues
  );

  const status = isNew
    ? CarInstanceConstants.VEHICLE_STATUS.NEW
    : CarInstanceConstants.VEHICLE_STATUS.OLD;

  const { route } = useRouteMatch({ routes: ROUTES }) ?? {};
  const { disabled } = useDisabledFields({ page: route });

  const onChange = useCallback((_, { type }) => {
    const isNew = type === CarInstanceConstants.VEHICLE_STATUS.NEW;

    dispatch(
      CarInstanceActions.setCarInstance({
        [CarInstanceConstants.VALUE_FIELDS.DEFAULT_PRICE]: 0,
        [CarInstanceConstants.VALUE_FIELDS.BRAND]: undefined,
        [CarInstanceConstants.VALUE_FIELDS.IS_NEW]: isNew,
        [CarInstanceConstants.VALUE_FIELDS.MILEAGE]: undefined,
        [CarInstanceConstants.VALUE_FIELDS.MODEL]: undefined,
        [CarInstanceConstants.VALUE_FIELDS.YEAR]: undefined,
        [CarInstanceConstants.VALUE_FIELDS.VERSION]: undefined,
      })
    );
    dispatch(
      CarInstanceActions.updateErrors({
        [CarInstanceConstants.VALUE_FIELDS.BRAND]: '',
        [CarInstanceConstants.VALUE_FIELDS.MILEAGE]: '',
        [CarInstanceConstants.VALUE_FIELDS.MODEL]: '',
        [CarInstanceConstants.VALUE_FIELDS.YEAR]: '',
        [CarInstanceConstants.VALUE_FIELDS.VERSION]: '',
      })
    );
    dispatch(
      CarReferenceActions.setSelected({
        [CarReferenceConstants.SELECTED_FIELDS.BRAND]: undefined,
        [CarReferenceConstants.SELECTED_FIELDS.MODEL]: undefined,
        [CarReferenceConstants.SELECTED_FIELDS.VERSION]: undefined,
      })
    );
  }, []);

  return { disabled, onChange, status };
};
